<i18n lang="yaml" locale="en">
  only one asset allowed: Do not drop more than one file here.
</i18n>

<i18n lang="yaml" locale="de">
  only one asset allowed: Legen Sie hier nicht mehr als eine Datei ab.
</i18n>

<template>
  <div class="file-drop">
    <div v-if="value">
      <component
        class="component"
        :is="componentLookup[contentType]"
        :src="value"
        :path="$store.getters.path"
        is-in-prop-editor
        :set-component-ref="false"
      />
      <span class="remove">
        <delete
          @click.native.stop="updateValue(undefined)"
          color="black"
          size="xs"
        />
      </span>
    </div>
    <span v-else>
      {{ $parent.$parent.t(placeholder) }}
    </span>
    <dropzone
      @drop="onDrop"
      :validation-fn="validateDrag"
    >
      {{ $parent.$parent.t(tooltip) }}
    </dropzone>
  </div>
</template>

<script>
import Dropzone from '@/components/editor/Dropzone'
import Delete from '@/components/icons/Delete'
import componentLookup from '@/components'
import { Error } from '@/plugins/snotify'

export default {
  components: {
    Dropzone,
    Delete
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    tooltip: {
      type: String,
      default: ''
    },
    contentType: {
      type: String,
      required: true
    }
  },
  computed: {
    componentLookup () {
      return componentLookup
    }
  },
  methods: {
    validateDrag (event) {
      if (event.dataTransfer.types.includes('assets')) {
        const paths = Object.keys(this.$root.$store.getters.selectedAssets)
        const accepted = paths.filter(path => {
          const module = this.$store.getters.modulesByPath[path]
          // only allow contentType
          return this.contentType === module.getters.type.name
        })
        return accepted.length > 0
      }
    },
    onDrop (event) {
      if (event.dataTransfer.getData('assets')) {
        const assets = Object.keys(this.$root.$store.getters.selectedAssets)
        if (assets.length > 1) {
          new Error(this.$t('only one asset allowed')).open()
        } else {
          const module = this.$store.getters.modulesByPath[assets[0]]
          this.updateValue(module.getters.props.src)
          this.$root.$store.dispatch('deselectAllAssets')
        }
      }
    },
    updateValue (value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/uiColors';

.file-drop {
  width: 100%;
  height: 100%;
  position: relative;
  text-align: center;
  border-radius: 3px;
  min-height: 100px;
  border: 2px dotted rgba($color: $color-main, $alpha: 0.5);
  padding: 5px;

  img {
    width: 100%;
  }

  .remove {
    position: absolute;
    background: #fff;
    padding: 5px;
    border-radius: 50%;
    line-height: 1;
    right: 10px;
    bottom: 10px;
  }
}
</style>
